// docs: https://github.com/altostra/type-validations#readme
import { anyOf, is, maybe, objectOf } from "@altostra/type-validations";
import { string, boolean, number } from "@altostra/type-validations/lib/primitives";

const targetingValidator = anyOf(
  is(null),
  objectOf({
    css_selector: string,
    insertion_position: string,
    url: maybe(string),
    url_match_type: maybe(string),
  })
);

export const isGetAppGroupsAppGroupIdPlacementsIdResult = objectOf({
  id: string,
  placement_id: string,
  name: string,
  description: string,
  marked_as_deleted: boolean,
  app_group_id: string,
  created_at: number,
  created_by_id: string,
  last_edited_at: number,
  last_edited_by_id: string,
  targeting: targetingValidator,
});

export const isPatchAppGroupsAppGroupIdPlacementsIdResult = objectOf({
  id: string,
  placement_id: string,
  name: string,
  description: string,
  marked_as_deleted: boolean,
  app_group_id: string,
  created_at: number,
  created_by_id: string,
  last_edited_at: number,
  last_edited_by_id: string,
  targeting: targetingValidator,
});
